export default "__VITE_ASSET__BDDSY9kz__ 640w, __VITE_ASSET__D77YKsla__ 1024w, __VITE_ASSET__CeSCeekU__ 1280w";